module.exports = __webpack_public_path__ + "html/offer-sending.component.html";